import { render, staticRenderFns } from "./list-overview.vue?vue&type=template&id=54a49b44&scoped=true&"
import script from "./list-overview.vue?vue&type=script&lang=js&"
export * from "./list-overview.vue?vue&type=script&lang=js&"
import style0 from "./list-overview.vue?vue&type=style&index=0&id=54a49b44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a49b44",
  null
  
)

export default component.exports